import { ConfigProvider, Select } from "antd";
// import "firebase/firestore";
import { useFormik } from "formik";
import { MapPin } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { BsShieldFillCheck, BsShieldFillExclamation } from "react-icons/bs";
import PhotoIcon from "../../assets/icons/photo.svg";
import apiClient from "../../helpers/apiClient";
import "./AddCar.css";
import TopBack from "../reservations/components/subcompdash/Topback";
import uploadFile from "../../utilities/uploadFile";
/** Car + list payloads use Mongo `location`/`id` as string, or `{ _id, id }` when populated. */
function locationRefToId(loc) {
    if (loc == null || loc === "") return "";
    if (typeof loc === "string") return loc === "undefined" ? "" : loc;
    if (typeof loc === "object") return String(loc._id ?? loc.id ?? "");
    return "";
}

// function delay(t, v) {
//     return new Promise((resolve) => {
//         setTimeout(resolve.bind(null, v), t);
//     });
// }

// function keepTrying(triesRemaining, storageRef) {
//     if (triesRemaining < 0) {
//         return Promise.reject(new Error("out of tries"));
//     }

//     return storageRef
//         .getDownloadURL()
//         .then((url) => url)
//         .catch((error) => {
//             switch (error.code) {
//                 case "storage/object-not-found":
//                     return delay(2000).then(() =>
//                         keepTrying(triesRemaining - 1, storageRef),
//                     );
//                 default:
//                     console.log(error);
//                     return Promise.reject(error);
//             }
//         });
// }

function AddCar() {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [categories, setCategories] = useState([]);

    const [allLocationOptions, setAllLocationOptions] = useState([]);

    const [insFile, setInsFile] = useState(null);

    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        const fetchLocations = async () => {
            setIsFetching(true);
            try {
                const response = await apiClient.get("/api/location/list?limit=200");

                if (response.data.success) {
                    // console.log(response.data.data);
                    const locations = response.data.data;
                    setAllLocationOptions(
                        locations.map((loc) => ({
                            value: String(loc.id ?? loc._id ?? ""),
                            label: (
                                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                    {loc.isInsuranceEnabled ? (
                                        <BsShieldFillCheck
                                            style={{ color: "#22c55e", fontSize: "0.9rem" }}
                                            title="Insurance enabled"
                                        />
                                    ) : (
                                        <BsShieldFillExclamation
                                            style={{ color: "#f59e0b", fontSize: "0.9rem" }}
                                            title="Insurance not enabled"
                                        />
                                    )}
                                    <span>{`${loc.city}, ${loc.state}`}</span>
                                </div>
                            ),
                            searchLabel: `${loc.city}, ${loc.state}`, // For search functionality
                            isInsuranceEnabled: loc.isInsuranceEnabled,
                        })),
                    );
                } else {
                    setError(response.data.message);
                }
            } catch (_error) {
                setError("Error fetching locations");
            } finally {
                setIsFetching(false);
            }
        };

        const fetchCategories = async () => {
            setIsFetching(true);
            try {
                const response = await apiClient.get("/api/car-category-v2/list?limit=200");

                // console.log(response.data);

                if (response.data.success) {
                    setCategories(response.data.data);
                } else {
                    setError(response.data.message);
                }
            } catch (_error) {
                setError("Error fetching categories");
            } finally {
                setIsFetching(false);
            }
        };
        fetchCategories();
        fetchLocations();
    }, []);

    const insFileChange = (e) => {
        if (e.target.files[0] && e.target.files[0].type === "application/pdf") {
            setInsFile(e.target.files[0]);
        }
    };

    const [regFile, setRegFile] = useState(null);

    const regFileChange = (e) => {
        if (e.target.files[0] && e.target.files[0].type === "application/pdf") {
            setRegFile(e.target.files[0]);
        }
    };

    const [serviceFile, setServiceFile] = useState(null);

    const serviceFileChange = (e) => {
        if (e.target.files[0] && e.target.files[0].type === "application/pdf") {
            setServiceFile(e.target.files[0]);
        }
    };

    const [car1, setCar1] = useState("");
    const [car2, setCar2] = useState("");
    const [car3, setCar3] = useState("");

    const [bodyType, setBodyType] = useState("");
    const [selectedBodyTypeId, setSelectedBodyTypeId] = useState("");

    const [selectedLocationId, setSelectedLocationId] = useState("");

    const onChangeSelectedLocation = (value) => {
        const newId = value?.value ?? value;
        setSelectedLocationId(newId);
    };

    const formik = useFormik({
        initialValues: {
            carName: "",
            trim: "",
            company: "",
            carNumber: "",
            status: "Locked",
            id: "",
            bodyType: "",
            category: "",
            VIN: "",
            fuelType: "",
            rates: {
                hourly: "",
                daily: "",
                weekly: "",
            },
            transmission: "",
            config: {
                make: "",
                model: "",
                year: "",
                doors: "",
                seats: "",
                color: "",
            },
            insurance: {
                company: "",
                policyNo: "",
                coverage: "",
                exp: "",
                doc: "",
            },
            registration: {
                state: "",
                exp: "",
                doc: "",
            },
            inspection: {
                last: "",
                exp: "",
                doc: "",
            },
            location: "",
            maintanenceMode: {},
            reservations: [],
            maintanence: [],
            images: {
                image1: "",
                image2: "",
                image3: "",
            },
            log: [
                {
                    title: "Car added",
                    time: new Date(),
                },
            ],
            isOwned: null,
            serialNumber: "0000000",
            leaseData: {
                startDate: "",
                accountNo: "",
                endDate: "",
                payment: "",
                milage: "",
                agency: "",
                duration: "",
                waiver: "",
                bankInfo: "",
            },
        },
        onSubmit: async (_values) => {
            const values = _values;
            setLoading(true);
            setError("");
            values.bodyType = bodyType;
            values.category = selectedBodyTypeId;
            values.categoryName = bodyType;

            // console.log(values, "submit form values");

            if (
                values.carName !== "" &&
                values.carNumber !== "" &&
                values.isOwned !== null &&
                values.bodyType !== "" &&
                values.VIN !== "" &&
                selectedLocationId &&
                (values.images.image1 !== "" || values.images.image2 !== "" || values.images.image3 !== "")
            ) {
                try {
                    values.images.image1 =
                        typeof values.images.image1 === "string"
                            ? values.images.image1
                            : await uploadFile(values.images.image1);
                    values.images.image2 =
                        typeof values.images.image2 === "string"
                            ? values.images.image2
                            : await uploadFile(values.images.image2);
                    values.images.image3 =
                        typeof values.images.image3 === "string"
                            ? values.images.image3
                            : await uploadFile(values.images.image3);
                    if (!values.images.image1) {
                        values.images.image1 = values.images.image2;
                    }
                    if (!values.images.image1) {
                        values.images.image1 = values.images.image3;
                    }
                    values.insurance.doc = insFile ? await uploadFile(insFile) : "";
                    values.registration.doc = regFile ? await uploadFile(regFile) : "";
                    values.inspection.doc = serviceFile ? await uploadFile(serviceFile) : "";
                    values.config.doors = values.config.doors || "";
                    values.config.seats = values.config.seats || "";
                    delete values.baseLocation;
                    delete values.baseLocationId;
                    delete values.location;
                    const effectiveLocationId = locationRefToId(selectedLocationId);
                    if (!effectiveLocationId) {
                        setError("Please select a valid location.");
                        setLoading(false);
                        return;
                    }
                    values.location = effectiveLocationId;
                    // console.log(values);

                    const response = await apiClient.post("/api/car/create", values);
                    if (response.data.success) {
                        setLoading(false);
                        formik.resetForm();
                        history.push("/cars"); // Redirect after success
                    } else {
                        setError(response?.data.message);
                        setLoading(false);
                    }
                } catch (_error) {
                    // console.log(error?.response);
                    if (
                        _error?.response?.data?.message === "Validation Error" &&
                        _error?.response?.data?.errorSources?.length > 0
                    ) {
                        setError("Please fill in all the required fields");
                    } else {
                        setError("Error submitting the form");
                    }
                    setLoading(false);
                }
            } else {
                setError("Please fill in all required fields");
                setLoading(false);
            }
        },
    });

    // console.log(formik.values);

    const car1Change = (e) => {
        if (e.target.files.length > 0) {
            const [file] = e.target.files;
            formik.values.images.image1 = file;
            setCar1(URL.createObjectURL(file));
        }
    };
    const car2Change = (e) => {
        if (e.target.files.length > 0) {
            const [file] = e.target.files;
            formik.values.images.image2 = file;
            setCar2(URL.createObjectURL(file));
        }
    };
    const car3Change = (e) => {
        if (e.target.files.length > 0) {
            const [file] = e.target.files;
            formik.values.images.image3 = file;
            setCar3(URL.createObjectURL(file));
        }
    };

    const getSelectedLocationInsuranceStatus = () => {
        const selectedLocation = allLocationOptions.find((loc) => loc.value === selectedLocationId);
        return selectedLocation?.isInsuranceEnabled || false;
    };

    // console formik values

    // console.log("values", formik.values);

    if (!isFetching && (categories.length === 0 || allLocationOptions.length === 0)) {
        return (
            <>
                <TopBack />
                <div className="min-h-[520px] flex flex-1 flex-col">
                    <div className="flex flex-col text-red-500 text-xl mt-5 ml-3 gap-3">
                        <div>Before adding a new car you must create</div>
                        {categories.length === 0 && (
                            <div>
                                &bull; A car body type. &nbsp;
                                <Link to="/cars/categories" className="underline font-semibold">
                                    Create body type
                                </Link>
                            </div>
                        )}
                        {allLocationOptions.length === 0 && (
                            <div>
                                &bull; A location. &nbsp;
                                <Link to="/cars/locations" className="underline font-semibold">
                                    Create location
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <TopBack />
            <div className="min-h-[520px] flex flex-1 flex-col">
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        // justifyContent: "space-between",
                        // marginBottom: "1.5rem",
                        alignItems: "start",
                    }}>
                    <div className="fontbold" style={{ fontSize: "1.3rem", flex: "1" }}>
                        New car!
                    </div>
                    {error && <div style={{ color: "red", marginRight: "1rem" }}>{error}</div>}
                    <div className="fontSemi" style={{ display: "flex", flexDirection: "row" }}>
                        <Link style={{ textDecoration: "none" }} to="/cars">
                            <div className="cancelbtn" style={{ marginRight: "1.5rem" }}>
                                Cancel
                            </div>
                        </Link>
                        {!loading ? (
                            <div className="updatebtn" onClick={formik.handleSubmit} onKeyUp={formik.handleSubmit}>
                                Save car
                            </div>
                        ) : (
                            <div className="updatebtn">Saving...</div>
                        )}
                    </div>
                </div>

                <div style={{ overflowY: "scroll", paddingTop: "1rem" }}>
                    <div
                        style={
                            {
                                // borderBottom: "1px solid #acacb9",
                                // paddingBottom: "0.4rem",
                            }
                        }>
                        <table className="fontRegular usertt2">
                            <tr>
                                <td style={{ width: "9rem" }}>
                                    Car title
                                    <span style={{ color: "red" }}>*</span>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="carName"
                                        onChange={formik.handleChange}
                                        value={formik.values.carName}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Trim</td>
                                <td>
                                    <input
                                        type="text"
                                        name="trim"
                                        onChange={formik.handleChange}
                                        value={formik.values.trim}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Company</td>
                                <td>
                                    <input
                                        type="text"
                                        name="company"
                                        onChange={formik.handleChange}
                                        value={formik.values.company}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>
                                    VIN<span style={{ color: "red" }}>*</span>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="VIN"
                                        onChange={formik.handleChange}
                                        value={formik.values.VIN}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>
                                    Plate number
                                    <span style={{ color: "red" }}>*</span>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="carNumber"
                                        onChange={formik.handleChange}
                                        value={formik.values.carNumber}
                                    />
                                </td>
                                <td
                                    style={{
                                        width: "9rem",
                                        fontWeight: "bold",
                                    }}>
                                    {process.env.REACT_APP_APPLICATION_TYPE === "dronemobile"
                                        ? "Dronemobile SN"
                                        : "Moovetrax Key"}
                                    <span style={{ color: "red" }}>*</span>
                                </td>
                                <td>
                                    <input
                                        disabled
                                        className="text-gray-400"
                                        type={
                                            process.env.REACT_APP_APPLICATION_TYPE === "dronemobile" ? "number" : "text"
                                        }
                                        name="serialNumber"
                                        onChange={formik.handleChange}
                                        value={formik.values.serialNumber}
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div
                        style={{
                            borderBottom: "1px solid #acacb9",
                            paddingTop: "0.7rem",
                            paddingBottom: "0.4rem",
                            fontSize: "1rem",
                        }}>
                        <div className="fontbold">Specification</div>
                        <table className="fontRegular usertt2">
                            <tr>
                                <td style={{ width: "9rem" }}>Make</td>
                                <td>
                                    <input
                                        type="text"
                                        name="config.make"
                                        onChange={formik.handleChange}
                                        value={formik.values.config.make}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Transmission</td>
                                <td>
                                    <input
                                        type="text"
                                        name="transmission"
                                        onChange={formik.handleChange}
                                        value={formik.values.transmission}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Doors</td>
                                <td>
                                    <input
                                        type="number"
                                        name="config.doors"
                                        onChange={formik.handleChange}
                                        value={formik.values.config.doors}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>
                                    Body type
                                    <span style={{ color: "red" }}>*</span>
                                </td>
                                <td className="SelectContainer">
                                    {/* <select
                    name="carType"
                    id="carType"
                    className="selectpck fontRegular"
                    style={{
                      height: "100%",
                      width: "13rem",
                      padding: "0.2rem",
                      paddingLeft: "4.8px",
                      margin: "0",
                      borderRadius: "0.6rem",
                      fontSize: "0.9rem"
                    }}
                    value={bodyType}
                    onChange={(e) => {
                      setBodyType(e.target.value);
                    }}
                  >
                    <option value="" className="selectItem">
                      Select body type
                    </option>
                    {categories?.map((category) => (
                      <option value={category.prevType} className="selectItem">
                        {category.name}
                      </option>
                    ))}
                  </select> */}
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    activeOutlineColor: "transparent",
                                                },
                                            },
                                        }}>
                                        <Select
                                            labelInValue
                                            showSearch
                                            id="carType"
                                            style={{
                                                width: "13rem",
                                                padding: "0.2rem",
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                                margin: 0,
                                                fontSize: "0.9rem",
                                            }}
                                            value={bodyType}
                                            optionFilterProp="label"
                                            onChange={(value) => {
                                                setBodyType(value.label);
                                                setSelectedBodyTypeId(value.value);
                                            }}
                                            options={categories.map((category) => ({
                                                value: category.id,
                                                label: category.categoryName,
                                            }))}
                                        />
                                    </ConfigProvider>
                                </td>
                                <td style={{ width: "9rem" }}>Model</td>
                                <td>
                                    <input
                                        type="text"
                                        name="config.model"
                                        onChange={formik.handleChange}
                                        value={formik.values.config.model}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Seats</td>
                                <td>
                                    <input
                                        type="number"
                                        name="config.seats"
                                        onChange={formik.handleChange}
                                        value={formik.values.config.seats}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>Fuel type</td>
                                <td>
                                    <input
                                        type="text"
                                        name="fuelType"
                                        onChange={formik.handleChange}
                                        value={formik.values.fuelType}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Year</td>
                                <td>
                                    <input
                                        type="text"
                                        name="config.year"
                                        onChange={formik.handleChange}
                                        value={formik.values.config.year}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Color</td>
                                <td>
                                    <input
                                        type="text"
                                        name="config.color"
                                        onChange={formik.handleChange}
                                        value={formik.values.config.color}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>
                                    Location
                                    <span style={{ color: "red" }}>*</span>
                                </td>
                                <td className="SelectContainer">
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    activeOutlineColor: "transparent",
                                                },
                                            },
                                        }}>
                                        <Select
                                            suffixIcon={<MapPin size={12} />}
                                            labelInValue
                                            showSearch
                                            id="carLocation"
                                            placeholder="Select a location"
                                            style={{
                                                width: "13rem",
                                                padding: "0.2rem",
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                                margin: 0,
                                                fontSize: "0.9rem",
                                            }}
                                            optionFilterProp="label"
                                            onChange={onChangeSelectedLocation}
                                            value={
                                                selectedLocationId
                                                    ? (() => {
                                                          const selOpt = allLocationOptions.find(
                                                              (loc) => loc.value === selectedLocationId,
                                                          );
                                                          return {
                                                              value: selectedLocationId,
                                                              label: (
                                                                  <div
                                                                      style={{
                                                                          display: "flex",
                                                                          alignItems: "center",
                                                                          gap: "0.5rem",
                                                                      }}>
                                                                      {selOpt?.isInsuranceEnabled ? (
                                                                          <BsShieldFillCheck
                                                                              style={{
                                                                                  color: "#22c55e",
                                                                                  fontSize: "0.9rem",
                                                                              }}
                                                                              title="Insurance enabled"
                                                                          />
                                                                      ) : (
                                                                          <BsShieldFillExclamation
                                                                              style={{
                                                                                  color: "#f59e0b",
                                                                                  fontSize: "0.9rem",
                                                                              }}
                                                                              title="Insurance not enabled"
                                                                          />
                                                                      )}
                                                                      <span>
                                                                          {selOpt?.searchLabel ?? selectedLocationId}
                                                                      </span>
                                                                  </div>
                                                              ),
                                                          };
                                                      })()
                                                    : undefined
                                            }
                                            options={allLocationOptions}
                                            filterOption={(input, option) =>
                                                (option?.searchLabel ?? "").toLowerCase().includes(input.toLowerCase())
                                            }
                                        />
                                    </ConfigProvider>

                                    {selectedLocationId && (
                                        <div style={{ marginLeft: "0.5rem" }}>
                                            {getSelectedLocationInsuranceStatus() ? (
                                                <BsShieldFillCheck
                                                    style={{ color: "#22c55e", fontSize: "1rem" }}
                                                    title="Insurance enabled for this location"
                                                />
                                            ) : (
                                                <BsShieldFillExclamation
                                                    style={{ color: "#f59e0b", fontSize: "1rem" }}
                                                    title="Insurance not enabled for this location"
                                                />
                                            )}
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div
                        style={{
                            borderBottom: "1px solid #acacb9",
                            paddingTop: ".7rem",
                            paddingBottom: "0.4rem",
                        }}>
                        <div className="fontbold">Insurance</div>
                        <table className="fontRegular usertt2">
                            <tr>
                                <td style={{ width: "9rem" }}>Company</td>
                                <td>
                                    <input
                                        type="text"
                                        name="insurance.company"
                                        onChange={formik.handleChange}
                                        value={formik.values.insurance.company}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Policy number</td>
                                <td>
                                    <input
                                        type="text"
                                        name="insurance.policyNo"
                                        onChange={formik.handleChange}
                                        value={formik.values.insurance.policyNo}
                                    />
                                </td>
                                <td
                                    rowSpan={2}
                                    colSpan={2}
                                    style={{
                                        width: "33%",
                                    }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}>
                                        <div
                                            className="scancopybtn"
                                            onClick={() => {
                                                const butt1 = document.getElementById("insfile");
                                                butt1.click();
                                            }}>
                                            scan copy
                                        </div>
                                        <span
                                            style={{
                                                color: "#acacb9",
                                                marginLeft: "1rem",
                                                width: "50%",
                                            }}>
                                            {/* no file choosen */}
                                            <input
                                                type="file"
                                                id="insfile"
                                                accept="application/pdf"
                                                onChange={insFileChange}
                                            />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>Coverage</td>
                                <td>
                                    <input
                                        type="text"
                                        name="insurance.coverage"
                                        onChange={formik.handleChange}
                                        value={formik.values.insurance.coverage}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Exp. date</td>
                                <td>
                                    <input
                                        type="date"
                                        name="insurance.exp"
                                        onChange={formik.handleChange}
                                        value={formik.values.insurance.exp}
                                    />
                                </td>
                            </tr>
                        </table>
                        <div
                            style={{
                                paddingBottom: "0.4rem",
                            }}>
                            <div className="fontbold">Registration</div>
                            <table className="fontRegular usertt2">
                                <tr>
                                    <td style={{ width: "9rem" }}>State</td>
                                    <td>
                                        <input
                                            type="text"
                                            name="registration.state"
                                            onChange={formik.handleChange}
                                            value={formik.values.registration.state}
                                        />
                                    </td>
                                    <td style={{ width: "9rem" }}>Exp. date</td>
                                    <td>
                                        <input
                                            type="date"
                                            name="registration.exp"
                                            onChange={formik.handleChange}
                                            value={formik.values.registration.exp}
                                        />
                                    </td>
                                    <td
                                        colSpan={2}
                                        style={{
                                            width: "33%",
                                        }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}>
                                            <div
                                                className="scancopybtn"
                                                onClick={() => {
                                                    const butt2 = document.getElementById("regfile");
                                                    butt2.click();
                                                }}>
                                                scan copy
                                            </div>
                                            <span
                                                style={{
                                                    color: "#acacb9",
                                                    marginLeft: "1rem",
                                                    width: "50%",
                                                }}>
                                                {/* no file choosen */}
                                                <input
                                                    type="file"
                                                    id="regfile"
                                                    accept="application/pdf"
                                                    onChange={regFileChange}
                                                />
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <div
                                style={{
                                    paddingBottom: "0.4rem",
                                }}>
                                <div className="fontbold">Service inspection</div>
                                <table className="fontRegular usertt2">
                                    <tr>
                                        <td style={{ width: "9rem" }}>Inspection date</td>
                                        <td>
                                            <input
                                                type="date"
                                                name="inspection.last"
                                                onChange={formik.handleChange}
                                                value={formik.values.inspection.last}
                                            />
                                        </td>
                                        <td style={{ width: "9rem" }}>Exp. date</td>
                                        <td>
                                            <input
                                                type="date"
                                                name="inspection.exp"
                                                onChange={formik.handleChange}
                                                value={formik.values.inspection.exp}
                                            />
                                        </td>
                                        <td
                                            colSpan={2}
                                            style={{
                                                width: "33%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}>
                                                <div
                                                    className="scancopybtn"
                                                    onClick={() => {
                                                        const butt3 = document.getElementById("servicefile");
                                                        butt3.click();
                                                    }}>
                                                    scan copy
                                                </div>
                                                <span
                                                    style={{
                                                        color: "#acacb9",
                                                        marginLeft: "1rem",
                                                        width: "50%",
                                                    }}>
                                                    {/* no file choosen */}
                                                    <input
                                                        type="file"
                                                        id="servicefile"
                                                        accept="application/pdf"
                                                        onChange={serviceFileChange}
                                                    />
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            paddingTop: ".7rem",
                            paddingBottom: "0.4rem",
                            borderBottom: "1px solid #acacb9",
                        }}>
                        <div
                            className="fontSemi"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}>
                            <input
                                type="radio"
                                id={formik.values.isOwned}
                                name="isOwned"
                                onChange={formik.handleChange}
                                value={false}
                            />{" "}
                            Leased
                            <input
                                type="radio"
                                id={formik.values.isOwned}
                                style={{ marginLeft: "3rem" }}
                                name="isOwned"
                                onChange={formik.handleChange}
                                value={true}
                            />{" "}
                            Owned
                        </div>
                        <table className="fontRegular usertt2" style={{ marginTop: "0.4rem" }}>
                            <tr>
                                <td style={{ width: "9rem" }}>Start date</td>
                                <td>
                                    <input
                                        type="date"
                                        name="leaseData.startDate"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.startDate}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>End date</td>
                                <td>
                                    <input
                                        type="date"
                                        name="leaseData.endDate"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.endDate}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Lease duration</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.duration"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.duration}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>Milage allowance</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.milage"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.milage}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Payment</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.payment"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.payment}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Bank info</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.bankInfo"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.bankInfo}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "9rem" }}>Account no.</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.accountNo"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.accountNo}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Leasing agency</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.agency"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.agency}
                                    />
                                </td>
                                <td style={{ width: "9rem" }}>Insurance waiver</td>
                                <td>
                                    <input
                                        type="text"
                                        name="leaseData.waiver"
                                        onChange={formik.handleChange}
                                        value={formik.values.leaseData.waiver}
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <input type="file" id="car1" onChange={car1Change} />
                    <input type="file" id="car2" onChange={car2Change} />
                    <input type="file" id="car3" onChange={car3Change} />
                    <div
                        style={{
                            paddingBottom: "0.4rem",
                            display: "flex",
                            flexDirection: "row",
                            paddingTop: "0.6rem",
                        }}>
                        <div
                            className="loadHandle"
                            style={{
                                height: "9rem",
                                width: "12rem",
                                backgroundColor: "white",
                                borderRadius: "1.2rem",
                                marginRight: "0.6rem",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                position: "relative",
                                overflow: "hidden",
                            }}
                            onClick={() => {
                                const img1 = document.getElementById("car1");
                                img1.click();
                            }}>
                            <img
                                src={car1}
                                alt=""
                                style={{
                                    position: "absolute",
                                    height: "100%",
                                    width: "100%",
                                    border: "none",
                                    outline: "none",
                                }}
                            />
                            <img src={PhotoIcon} alt="" style={{ height: "4rem" }} />
                            <div
                                className="fontSemi"
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.7rem",
                                    paddingTop: "0.2rem",
                                    color: "#acacb9",
                                }}>
                                Click here to
                                <br />
                                Upload photo 01
                            </div>
                        </div>

                        <div
                            style={{
                                height: "9rem",
                                width: "12rem",
                                backgroundColor: "white",
                                borderRadius: "1.2rem",
                                marginRight: "0.6rem",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                position: "relative",
                                overflow: "hidden",
                            }}
                            onClick={() => {
                                const img2 = document.getElementById("car2");
                                img2.click();
                            }}>
                            <img
                                src={car2}
                                alt=""
                                style={{
                                    position: "absolute",
                                    height: "100%",
                                    width: "100%",
                                    border: "none",
                                    outline: "none",
                                }}
                            />
                            <img src={PhotoIcon} alt="" style={{ height: "4rem" }} />
                            <div
                                className="fontSemi"
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.7rem",
                                    paddingTop: "0.2rem",
                                    color: "#acacb9",
                                }}>
                                Click here to
                                <br />
                                Upload photo 02
                            </div>
                        </div>
                        <div
                            style={{
                                height: "9rem",
                                width: "12rem",
                                backgroundColor: "white",
                                borderRadius: "1.2rem",
                                marginRight: "0.6rem",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                position: "relative",
                                overflow: "hidden",
                            }}
                            onClick={() => {
                                const img3 = document.getElementById("car3");
                                img3.click();
                            }}>
                            <img
                                src={car3}
                                alt=""
                                style={{
                                    position: "absolute",
                                    height: "100%",
                                    width: "100%",
                                    border: "none",
                                    outline: "none",
                                    objectFit: "cover",
                                }}
                            />
                            <img src={PhotoIcon} alt="" style={{ height: "4rem" }} />
                            <div
                                className="fontSemi"
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.7rem",
                                    paddingTop: "0.2rem",
                                    color: "#acacb9",
                                }}>
                                Click here to
                                <br />
                                Upload photo 03
                            </div>
                        </div>
                        <div
                            style={{
                                width: "1px",
                                height: "8rem",
                                backgroundColor: "#acacb9",
                                marginTop: ".5rem",
                                opacity: "0.7",
                            }}
                        />
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}>
                            {/* <table
                style={{ margin: "0.5rem", width: "20rem" }}
                className="fontRegular usertt2"
              >
                <tr>
                  <td>Hourly rate [USD]<span style={{ color:"red" }}>*</span></td>
                  <td>
                    <input
                      type="number"
                      name="rates.hourly"
                      onChange={formik.handleChange}
                      value={formik.values.rates.hourly}
                      style={{ width: "22rem" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Daily rate [USD]<span style={{ color:"red" }}>*</span></td>
                  <td>
                    <input
                      type="number"
                      name="rates.daily"
                      onChange={formik.handleChange}
                      value={formik.values.rates.daily}
                      style={{ width: "22rem" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Weekly rate [USD]<span style={{ color:"red" }}>*</span></td>
                  <td>
                    <input
                      type="number"
                      name="rates.weekly"
                      onChange={formik.handleChange}
                      value={formik.values.rates.weekly}
                      style={{ width: "22rem" }}
                    />
                  </td>
                </tr>
              </table> */}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default AddCar;
